import Icon from "../Icon/Icon";
import LoaderCircle from "../LoaderCircle/LoaderCircle";
import { FieldHelper } from "./fieldParts";
import { PropsWithChildren } from "react";
import { StatusType } from "./types";

const FieldHintIcon = ({ status }: { status?: StatusType }) => {
  switch (status) {
    case "error":
      return <Icon name="alert-triangle" fontSize="100" />;
    case "warning":
      return <Icon name="alert-circle" fontSize="100" />;
    case "success":
      return <Icon name="check-01-circle" fontSize="100" />;
    case "loading":
      return <LoaderCircle type="neutral" size="small" />;
    default:
      return null;
  }
};

export interface FieldHintProps extends PropsWithChildren {
  status?: StatusType;
}

export const FieldHint = ({ children, status }: FieldHintProps) => (
  <FieldHelper>
    <FieldHintIcon status={status} />
    {children}
  </FieldHelper>
);
